// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-0dbd65a0] .el-dialog__header{display:none !important}.selfDialogClose[data-v-0dbd65a0]{display:inline-block;position:absolute;right:0;top:3px;pointer-events:auto;z-index:999;font-size:16px;color:#363f4d}", ""]);
// Exports
module.exports = exports;
